export const videosList = [
  {
    id: 1,
    title: "Future of Digital Customer Experience",
    category: "Digital Customer",
    filtercat: "Digital Customer",
    thumbnail: `${process.env.PUBLIC_URL}/Assets/IgniteTalks/digitalcustomer/digi-cus-thumb1.png`,
    duration: "60 min",
    courseDate: "12-Dec-2025",
    speakerName: "Sunjeet Gupta",
    speakerImage: `${process.env.PUBLIC_URL}/Assets/IgniteTalks/sunjeet-speaker.png`,
    courseDescription:
      "This learning series explores how customer interactions are shifting from static, channel‑led designs to dynamic, contextual, multimodal, and agentic ecosystems. Experiences no longer stay still — they adapt continuously based on behavior, signals, data, and intent.",
    mainVideo: {
      title: "Introduction of Digital",
    },
    episodes: [
      {
        title: "Future of Experience",
        description:
          "The World is no longer designed once. It is redesigned every day by data, behavior, markets..",
        url: `${process.env.PUBLIC_URL}/Assets/IgniteTalks/fdcevideo1.mp4`,
        thumbnail: `${process.env.PUBLIC_URL}/Assets/IgniteTalks/digitalcustomer/digi-cus-thumb1.png`,
        duration: "8 min",
        date: "Dec-12-2025",
      },
      {
        title: "Evolution of Newer Channels",
        description:
          "Traditional continues, newer ones wants attention of your brand..",

        url: `${process.env.PUBLIC_URL}/Assets/IgniteTalks/fdcevideo2.mp4`,
        thumbnail: `${process.env.PUBLIC_URL}/Assets/IgniteTalks/digitalcustomer/digi-cus-thumb2.png`,
        duration: "6 min",
        date: "Dec-15-2025",
      },
      {
        title: "Agentic is Seeping Inside Platforms",
        description:
          "Platforms are gearing for the agentic future explosion, one bit at a time..",

        url: `${process.env.PUBLIC_URL}/Assets/IgniteTalks/fdcevideo3.mp4`,
        thumbnail: `${process.env.PUBLIC_URL}/Assets/IgniteTalks/digitalcustomer/digi-cus-thumb3.png`,
        duration: "6 min",
        date: "Dec-15-2025",
      },
      {
        title: "Traditional Products are Decimated",
        description:
          "Do i really need niche product which combine data,intelligence, experience, insights..",

        url: `${process.env.PUBLIC_URL}/Assets/IgniteTalks/fdcevideo4.mp4`,
        thumbnail: `${process.env.PUBLIC_URL}/Assets/IgniteTalks/digitalcustomer/digi-cus-thumb4.png`,
        duration: "14 min",
        date: "Dec-15-2025",
      },
      {
        title: "Voice Interactions",
        description:
          "Looks funny, but you will soon be having your companion talking to these funny voice bots to get tasks done..",

        url: `${process.env.PUBLIC_URL}/Assets/IgniteTalks/fdcevideo5.mp4`,
        thumbnail: `${process.env.PUBLIC_URL}/Assets/IgniteTalks/digitalcustomer/digi-cus-thumb5.png`,
        duration: "5 min",
        date: "Dec-15-2025",
      },
      {
        title: "Visual Experiences",
        description:
          "Every brand with their products will want a much direct connect..",

        url: `${process.env.PUBLIC_URL}/Assets/IgniteTalks/fdcevideo6.mp4`,
        thumbnail: `${process.env.PUBLIC_URL}/Assets/IgniteTalks/digitalcustomer/digi-cus-thumb6.png`,
        duration: "3 min",
        date: "Dec-15-2025",
      },
      {
        title: "Adaptive X",
        description:
          "Bygones are traditional way to traverse the digital walkways, the new walkways will form where you step in..",

        url: `${process.env.PUBLIC_URL}/Assets/IgniteTalks/fdcevideo7.mp4`,
        thumbnail: `${process.env.PUBLIC_URL}/Assets/IgniteTalks/digitalcustomer/digi-cus-thumb7.png`,
        duration: "9 min",
        date: "Dec-15-2025",
      },
      {
        title: "Your Digital Assistant",
        description:
          "You have a digital assistant, you control your work, cart, task while brands just get to fulfil and not own it..",
        url: `${process.env.PUBLIC_URL}/Assets/IgniteTalks/fdcevideo8.mp4`,
        thumbnail: `${process.env.PUBLIC_URL}/Assets/IgniteTalks/digitalcustomer/digi-cus-thumb8.png`,
        duration: "7 min",
        date: "Dec-15-2025",
      },
    ],
  },
  {
    id: 2,
    title: "Adobe AI and Agents powered Marketing ReInvention",
    category: "Agentic AI",
    filtercat: "Technology",
    thumbnail: `${process.env.PUBLIC_URL}/Assets/IgniteTalks/agenticai/agentic-ai-thumb1.png`,
    duration: "60 min",
    courseDate: "09-Jan-2026",
    speakerName: "Prateek Shrivastav",
    speakerImage: `${process.env.PUBLIC_URL}/Assets/IgniteTalks/prateek-speaker.png`,
    courseDescription:
      "An engaging session on Adobe AI, with a special focus on the AEM GenAI TDLC and its transformative impact across various lifecycle stages. This masterclass delves into the intersection of Adobe/Marketing AI and TDLC, showcasing key assets and strategies that are already deployed in projects. Discover the role of AI in the Content Supply Chain and Marketing Activation. Explore Accenture's Adobe AEM GenAI TDLC, featuring a showcase of lifecycle assets.",
    mainVideo: {
      title: "Introduction of Digital",
    },
    episodes: [
      {
        title: "Directions with Adobe AI",
        description: "",
        url: `${process.env.PUBLIC_URL}/Assets/IgniteTalks/othertalks1.mp4`,
        thumbnail: `${process.env.PUBLIC_URL}/Assets/IgniteTalks/agenticai/agentic-ai-thumb1.png`,
        duration: "10 min",
        date: "Dec-12-2025",
      },
      {
        title: "Adobe Firefly",
        description: "",

        url: `${process.env.PUBLIC_URL}/Assets/IgniteTalks/othertalks2.mp4`,
        thumbnail: `${process.env.PUBLIC_URL}/Assets/IgniteTalks/agenticai/agentic-ai-thumb2.png`,
        duration: "11 min",
        date: "Dec-15-2025",
      },
      {
        title: "Adobe GenStudio",
        description: "",

        url: `${process.env.PUBLIC_URL}/Assets/IgniteTalks/othertalks3.mp4`,
        thumbnail: `${process.env.PUBLIC_URL}/Assets/IgniteTalks/agenticai/agentic-ai-thumb3.png`,
        duration: "15 min",
        date: "Dec-15-2025",
      },
      {
        title: "Intelligent TDLC Agents",
        description: "",

        url: `${process.env.PUBLIC_URL}/Assets/IgniteTalks/othertalks4.mp4`,
        thumbnail: `${process.env.PUBLIC_URL}/Assets/IgniteTalks/agenticai/agentic-ai-thumb4.png`,
        duration: "10 min",
        date: "Dec-15-2025",
      },
      {
        title:
          "Accelerating the Adobe Delivery Lifecycle with Agentic AI - Q&A",
        description: "",

        url: `${process.env.PUBLIC_URL}/Assets/IgniteTalks/othertalks5.mp4`,
        thumbnail: `${process.env.PUBLIC_URL}/Assets/IgniteTalks/agenticai/agentic-ai-thumb5.png`,
        duration: "8 min",
        date: "Dec-15-2025",
      },
    ],
  },
  {
    id: 3,
    title: "The power of Generative AI",
    category: "Generative AI",
    filtercat: "Gen AI",
    thumbnail: `${process.env.PUBLIC_URL}/Assets/IgniteTalks/genai/genai-thumb1.png`,
    duration: "37 min",
    courseDate: "09-Jan-2026",
    speakerName: "Neha Kukreja",
    speakerImage: `${process.env.PUBLIC_URL}/Assets/IgniteTalks/Avatar.png`,
    courseDescription:
      "This learning series introduces participants to Generative AI (GenAI), explaining how it boosts productivity, enhances creativity, and transforms daily work at Accenture. Across the modules, learners explore the evolution of AI, the fundamentals of effective prompting, the REACH framework, hands-on demonstrations of tools like Amethyst and M365 Copilot, and practical ways to integrate GenAI into everyday tasks. The program equips employees with actionable guidance to adopt GenAI responsibly and effectively in their roles.",
    mainVideo: {
      title: "Gen AI Tools at Accenture",
    },
    episodes: [
      {
        title: "Gen AI Tools at Accenture",
        description: "",
        url: `${process.env.PUBLIC_URL}/Assets/IgniteTalks/genai/genai-video1.mp4`,
        thumbnail: `${process.env.PUBLIC_URL}/Assets/IgniteTalks/genai/genai-thumb1.png`,
        duration: "8 min",
        date: "Dec-12-2025",
      },
      {
        title: "Effective Prompting",
        description: "",
        url: `${process.env.PUBLIC_URL}/Assets/IgniteTalks/genai/genai-video2.mp4`,
        thumbnail: `${process.env.PUBLIC_URL}/Assets/IgniteTalks/genai/genai-thumb2.png`,
        duration: "4 min",
        date: "Dec-12-2025",
      },
      {
        title: "REACH Framework",
        description: "",
        url: `${process.env.PUBLIC_URL}/Assets/IgniteTalks/genai/genai-video3.mp4`,
        thumbnail: `${process.env.PUBLIC_URL}/Assets/IgniteTalks/genai/genai-thumb3.png`,
        duration: "5 min",
        date: "Dec-12-2025",
      },
      {
        title: "Gen AI Tools in Action",
        description: "",
        url: `${process.env.PUBLIC_URL}/Assets/IgniteTalks/genai/genai-video4.mp4`,
        thumbnail: `${process.env.PUBLIC_URL}/Assets/IgniteTalks/genai/genai-thumb4.png`,
        duration: "14 min",
        date: "Dec-12-2025",
      },
      {
        title: "Day in Your Life with Gen AI Tools",
        description: "",
        url: `${process.env.PUBLIC_URL}/Assets/IgniteTalks/genai/genai-video5.mp4`,
        thumbnail: `${process.env.PUBLIC_URL}/Assets/IgniteTalks/genai/genai-thumb5.png`,
        duration: "5 min",
        date: "Dec-12-2025",
      },
    ],
  },
  {
    id: 4,
    title: "Explore M365 Copilot",
    category: "M365 Copilot",
    filtercat: "Gen AI",
    thumbnail: `${process.env.PUBLIC_URL}/Assets/IgniteTalks/m365/m365-thumb1.png`,
    duration: "40 min",
    courseDate: "09-Jan-2026",
    speakerName: "Apoorva Sharma",
    speakerImage: `${process.env.PUBLIC_URL}/Assets/IgniteTalks/Avatar.png`,
    courseDescription: "",
    mainVideo: {
      title: "M365 Copilot Summarize",
    },
    episodes: [
      {
        title: "M365 Copilot Summarize",
        description: "",
        url: `${process.env.PUBLIC_URL}/Assets/IgniteTalks/m365/m365-video1.mp4`,
        thumbnail: `${process.env.PUBLIC_URL}/Assets/IgniteTalks/m365/m365-thumb1.png`,
        duration: "11 min",
        date: "Dec-12-2025",
      },
      {
        title: "M365 Copilot Assist",
        description: "",
        url: `${process.env.PUBLIC_URL}/Assets/IgniteTalks/m365/m365-video2.mp4`,
        thumbnail: `${process.env.PUBLIC_URL}/Assets/IgniteTalks/m365/m365-thumb2.png`,
        duration: "10 min",
        date: "Dec-12-2025",
      },
      {
        title: "M365 Copilot Ideate and Evaluate",
        description: "",
        url: `${process.env.PUBLIC_URL}/Assets/IgniteTalks/m365/m365-video3.mp4`,
        thumbnail: `${process.env.PUBLIC_URL}/Assets/IgniteTalks/m365/m365-thumb3.png`,
        duration: "15 min",
        date: "Dec-12-2025",
      },
      {
        title: "Prompting with Generative AI",
        description: "",
        url: `${process.env.PUBLIC_URL}/Assets/IgniteTalks/m365/m365-video4.mp4`,
        thumbnail: `${process.env.PUBLIC_URL}/Assets/IgniteTalks/m365/m365-thumb4.png`,
        duration: "2 min",
        date: "Dec-12-2025",
      },
    ],
  },
  {
    id: 5,
    title: "Explore M365 Copilot - Teams and Outlook",
    category: "M365 Copilot",
    filtercat: "Gen AI",
    thumbnail: `${process.env.PUBLIC_URL}/Assets/IgniteTalks/m365/m365-teams-thumb1.png`,
    duration: "43 min",
    courseDate: "09-Jan-2026",
    speakerName: "Nimisha Pathak, Neha Kukreja",
    speakerImage: `${process.env.PUBLIC_URL}/Assets/IgniteTalks/Avatar.png`,
    courseDescription: "",
    mainVideo: {
      title: "Explore 365 CoPilot - Teams and Outlook ",
    },
    episodes: [
      {
        title: "Explore 365 CoPilot - Teams and Outlook ",
        description: "",
        url: `${process.env.PUBLIC_URL}/Assets/IgniteTalks/m365/m365-teams-video1.mp4`,
        thumbnail: `${process.env.PUBLIC_URL}/Assets/IgniteTalks/m365/m365-teams-thumb1.png`,
        duration: "5 min",
        date: "Dec-12-2025",
      },
      {
        title: "Behaviors of M365 Copilot- Microsoft Teams",
        description: "",
        url: `${process.env.PUBLIC_URL}/Assets/IgniteTalks/m365/m365-teams-video2.mp4`,
        thumbnail: `${process.env.PUBLIC_URL}/Assets/IgniteTalks/m365/m365-teams-thumb2.png`,
        duration: "27 min",
        date: "Dec-12-2025",
      },
      {
        title: "Behaviors of M365 Copilot- Microsoft Outlook ",
        description: "",
        url: `${process.env.PUBLIC_URL}/Assets/IgniteTalks/m365/m365-teams-video3.mp4`,
        thumbnail: `${process.env.PUBLIC_URL}/Assets/IgniteTalks/m365/m365-teams-thumb3.png`,
        duration: "11 min",
        date: "Dec-12-2025",
      },
      {
        title: "Prompting with Generative AI",
        description: "",
        url: `${process.env.PUBLIC_URL}/Assets/IgniteTalks/m365/m365-teams-video4.mp4`,
        thumbnail: `${process.env.PUBLIC_URL}/Assets/IgniteTalks/m365/m365-teams-thumb4.png`,
        duration: "2 min",
        date: "Dec-12-2025",
      },
    ],
  },
  {
    id: 6,
    title: "OWP Automation Process and Success stories",
    category: "OWP Automation Process",
    filtercat: "Success story",
    thumbnail: `${process.env.PUBLIC_URL}/Assets/IgniteTalks/sucessstory/owp-thumb1.png`,
    duration: "35 min",
    courseDate: "09-Jan-2026",
    speakerName: "Bandana Sahoo",
    speakerImage: `${process.env.PUBLIC_URL}/Assets/IgniteTalks/Avatar.png`,
    courseDescription: "",
    mainVideo: {
      title: "Roche OWP Automation",
    },
    episodes: [
      {
        title: "Roche OWP Automation",
        description: "",
        url: `${process.env.PUBLIC_URL}/Assets/IgniteTalks/sucessstory/owp-video1.mp4`,
        thumbnail: `${process.env.PUBLIC_URL}/Assets/IgniteTalks/sucessstory/owp-thumb1.png`,
        duration: "7 min",
        date: "Dec-12-2025",
      },
      {
        title: "Automation Tools",
        description: "",
        url: `${process.env.PUBLIC_URL}/Assets/IgniteTalks/sucessstory/owp-video2.mp4`,
        thumbnail: `${process.env.PUBLIC_URL}/Assets/IgniteTalks/sucessstory/owp-thumb2.png`,
        duration: "9 min",
        date: "Dec-12-2025",
      },
      {
        title: "Automation & Best Practices for Microsoft Adobe Support Center",
        description: "",
        url: `${process.env.PUBLIC_URL}/Assets/IgniteTalks/sucessstory/owp-video3.mp4`,
        thumbnail: `${process.env.PUBLIC_URL}/Assets/IgniteTalks/sucessstory/owp-thumb3.png`,
        duration: "6 min",
        date: "Dec-12-2025",
      },
      {
        title: "Impact of Automation ",
        description: "",
        url: `${process.env.PUBLIC_URL}/Assets/IgniteTalks/sucessstory/owp-video4.mp4`,
        thumbnail: `${process.env.PUBLIC_URL}/Assets/IgniteTalks/sucessstory/owp-thumb4.png`,
        duration: "7 min",
        date: "Dec-12-2025",
      },
      {
        title: "Automation is the multiplier ",
        description: "",
        url: `${process.env.PUBLIC_URL}/Assets/IgniteTalks/sucessstory/owp-video5.mp4`,
        thumbnail: `${process.env.PUBLIC_URL}/Assets/IgniteTalks/sucessstory/owp-thumb5.png`,
        duration: "5 min",
        date: "Dec-12-2025",
      },
    ],
  },
  {
    id: 7,
    title: "More Than Just Storage: The Strategic Advantage of DAM",
    category: "The Strategic Advantage of DAM",
    filtercat: "Best practices",
    thumbnail: `${process.env.PUBLIC_URL}/Assets/IgniteTalks/bestpractices/dam-thumb1.png`,
    duration: "42 min",
    courseDate: "09-Jan-2026",
    speakerName: "Shrivastava, Sujata",
    speakerImage: `${process.env.PUBLIC_URL}/Assets/IgniteTalks/Avatar.png`,
    courseDescription: "",
    mainVideo: {
      title: "What is Digital Asset Management",
    },
    episodes: [
      {
        title: "What is Digital Asset Management",
        description: "",
        url: `${process.env.PUBLIC_URL}/Assets/IgniteTalks/bestpractices/dam-video1.mp4`,
        thumbnail: `${process.env.PUBLIC_URL}/Assets/IgniteTalks/bestpractices/dam-thumb1.png`,
        duration: "15 min",
        date: "Dec-12-2025",
      },
      {
        title: "DAM Use Cases Implemented in Recent Projects ",
        description: "",
        url: `${process.env.PUBLIC_URL}/Assets/IgniteTalks/bestpractices/dam-video2.mp4`,
        thumbnail: `${process.env.PUBLIC_URL}/Assets/IgniteTalks/bestpractices/dam-thumb2.png`,
        duration: "11 min",
        date: "Dec-12-2025",
      },
      {
        title: "Your Assets, Your Advantage",
        description: "",
        url: `${process.env.PUBLIC_URL}/Assets/IgniteTalks/bestpractices/dam-video3.mp4`,
        thumbnail: `${process.env.PUBLIC_URL}/Assets/IgniteTalks/bestpractices/dam-thumb3.png`,
        duration: "3 min",
        date: "Dec-12-2025",
      },
      {
        title: "Make Your Meetings More Engaging ",
        description: "",
        url: `${process.env.PUBLIC_URL}/Assets/IgniteTalks/bestpractices/dam-video4.mp4`,
        thumbnail: `${process.env.PUBLIC_URL}/Assets/IgniteTalks/bestpractices/dam-thumb4.png`,
        duration: "12 min",
        date: "Dec-12-2025",
      },
    ],
  },
  {
    id: 8,
    title: "Release management process and best practices",
    category: "Release management process",
    filtercat: "Best practices",
    thumbnail: `${process.env.PUBLIC_URL}/Assets/IgniteTalks/bestpractices/rmp-thumb1.png`,
    duration: "48 min",
    courseDate: "09-Jan-2026",
    speakerName: "Nandini Paranjothi",
    speakerImage: `${process.env.PUBLIC_URL}/Assets/IgniteTalks/Avatar.png`,
    courseDescription: "",
    mainVideo: {
      title: "Release Management Cycle",
    },
    episodes: [
      {
        title: "Release Management Cycle",
        description: "",
        url: `${process.env.PUBLIC_URL}/Assets/IgniteTalks/bestpractices/rmp-video1.mp4`,
        thumbnail: `${process.env.PUBLIC_URL}/Assets/IgniteTalks/bestpractices/rmp-thumb1.png`,
        duration: "18 min",
        date: "Dec-12-2025",
      },
      {
        title: "Release Management Cycle Discussion",
        description: "",
        url: `${process.env.PUBLIC_URL}/Assets/IgniteTalks/bestpractices/rmp-video2.mp4`,
        thumbnail: `${process.env.PUBLIC_URL}/Assets/IgniteTalks/bestpractices/rmp-thumb2.png`,
        duration: "4 min",
        date: "Dec-12-2025",
      },
      {
        title: "Explore Microsoft To do ",
        description: "",
        url: `${process.env.PUBLIC_URL}/Assets/IgniteTalks/bestpractices/rmp-video3.mp4`,
        thumbnail: `${process.env.PUBLIC_URL}/Assets/IgniteTalks/bestpractices/rmp-thumb3.png`,
        duration: "15 min",
        date: "Dec-12-2025",
      },
      {
        title: "Practice To-do",
        description: "",
        url: `${process.env.PUBLIC_URL}/Assets/IgniteTalks/bestpractices/rmp-video4.mp4`,
        thumbnail: `${process.env.PUBLIC_URL}/Assets/IgniteTalks/bestpractices/rmp-thumb4.png`,
        duration: "9 min",
        date: "Dec-12-2025",
      },
      {
        title: "Keyboard Shortcuts",
        description: "",
        url: `${process.env.PUBLIC_URL}/Assets/IgniteTalks/bestpractices/rmp-video5.mp4`,
        thumbnail: `${process.env.PUBLIC_URL}/Assets/IgniteTalks/bestpractices/rmp-thumb5.png`,
        duration: "1 min",
        date: "Dec-12-2025",
      },
    ],
  },
  {
    id: 9,
    title: "LCNC Capabilities @Accenture",
    category: "LCNC Capabilities",
    filtercat: "LCNC",
    thumbnail: `${process.env.PUBLIC_URL}/Assets/IgniteTalks/lcnc/capability-thumb1.png`,
    duration: "45 min",
    courseDate: "09-Jan-2026",
    speakerName: "Samuel Kore, Joel",
    speakerImage: `${process.env.PUBLIC_URL}/Assets/IgniteTalks/Avatar.png`,
    courseDescription: "",
    mainVideo: {
      title: "Low Code No Code Experience ",
    },
    episodes: [
      {
        title: "Low Code No Code Experience ",
        description: "",
        url: `${process.env.PUBLIC_URL}/Assets/IgniteTalks/lcnc/capability-video1.mp4`,
        thumbnail: `${process.env.PUBLIC_URL}/Assets/IgniteTalks/lcnc/capability-thumb1.png`,
        duration: "20 min",
        date: "Dec-12-2025",
      },
      {
        title: "Demo - Mendix + (GenAI) AWS Bedrock",
        description: "",
        url: `${process.env.PUBLIC_URL}/Assets/IgniteTalks/lcnc/capability-video2.mp4`,
        thumbnail: `${process.env.PUBLIC_URL}/Assets/IgniteTalks/lcnc/capability-thumb2.png`,
        duration: "4 min",
        date: "Dec-12-2025",
      },
      {
        title: "How to Create a App with Mendix ",
        description: "",
        url: `${process.env.PUBLIC_URL}/Assets/IgniteTalks/lcnc/capability-video3.mp4`,
        thumbnail: `${process.env.PUBLIC_URL}/Assets/IgniteTalks/lcnc/capability-thumb3.png`,
        duration: "15 min",
        date: "Dec-12-2025",
      },
      {
        title: "Low Code No Code Experience - Q&A",
        description: "",
        url: `${process.env.PUBLIC_URL}/Assets/IgniteTalks/lcnc/capability-video4.mp4`,
        thumbnail: `${process.env.PUBLIC_URL}/Assets/IgniteTalks/lcnc/capability-thumb4.png`,
        duration: "4 min",
        date: "Dec-12-2025",
      },
    ],
  },
  {
    id: 10,
    title: "LCNC : Mendix Success Story",
    category: "",
    filtercat: "LCNC",
    thumbnail: `${process.env.PUBLIC_URL}/Assets/IgniteTalks/lcnc/mendix-thumb1.png`,
    duration: "49 min",
    courseDate: "09-Jan-2026",
    speakerName: "Sharad Kulkarni",
    speakerImage: `${process.env.PUBLIC_URL}/Assets/IgniteTalks/Avatar.png`,
    courseDescription: "",
    mainVideo: {
      title: "Empowering Business with Mendix",
    },
    episodes: [
      {
        title: "Empowering Business with Mendix",
        description: "",
        url: `${process.env.PUBLIC_URL}/Assets/IgniteTalks/lcnc/mendix-video1.mp4`,
        thumbnail: `${process.env.PUBLIC_URL}/Assets/IgniteTalks/lcnc/mendix-thumb1.png`,
        duration: "12 min",
        date: "Dec-12-2025",
      },
      {
        title: "M4E & CISS ",
        description: "",
        url: `${process.env.PUBLIC_URL}/Assets/IgniteTalks/lcnc/mendix-video2.mp4`,
        thumbnail: `${process.env.PUBLIC_URL}/Assets/IgniteTalks/lcnc/mendix-thumb2.png`,
        duration: "5 min",
        date: "Dec-12-2025",
      },
      {
        title: "M4E & CISS Demo",
        description: "",
        url: `${process.env.PUBLIC_URL}/Assets/IgniteTalks/lcnc/mendix-video3.mp4`,
        thumbnail: `${process.env.PUBLIC_URL}/Assets/IgniteTalks/lcnc/mendix-thumb3.png`,
        duration: "6 min",
        date: "Dec-12-2025",
      },
      {
        title: "Explore Copilot for Power Automate",
        description: "",
        url: `${process.env.PUBLIC_URL}/Assets/IgniteTalks/lcnc/mendix-video4.mp4`,
        thumbnail: `${process.env.PUBLIC_URL}/Assets/IgniteTalks/lcnc/mendix-thumb4.png`,
        duration: "13 min",
        date: "Dec-12-2025",
      },
      {
        title: "Create your Automation with Copilot",
        description: "",
        url: `${process.env.PUBLIC_URL}/Assets/IgniteTalks/lcnc/mendix-video5.mp4`,
        thumbnail: `${process.env.PUBLIC_URL}/Assets/IgniteTalks/lcnc/mendix-thumb5.png`,
        duration: "5 min",
        date: "Dec-12-2025",
      },
      {
        title: "Power Automate Discussion",
        description: "",
        url: `${process.env.PUBLIC_URL}/Assets/IgniteTalks/lcnc/mendix-video6.mp4`,
        thumbnail: `${process.env.PUBLIC_URL}/Assets/IgniteTalks/lcnc/mendix-thumb6.png`,
        duration: "6 min",
        date: "Dec-12-2025",
      },
    ],
  },
  {
    id: 11,
    title: "SEO and Its business Impact",
    category: "SEO and Its business Impact",
    filtercat: "Best practices",
    thumbnail: `${process.env.PUBLIC_URL}/Assets/IgniteTalks/bestpractices/seo-thumb1.png`,
    duration: "38 min",
    courseDate: "09-Jan-2026",
    speakerName: "Devpal Singh",
    speakerImage: `${process.env.PUBLIC_URL}/Assets/IgniteTalks/Avatar.png`,
    courseDescription:
      "This learning series introduces the fundamentals of Search Engine Optimization (SEO) and explains how search engines crawl, index, and rank websites. It highlights SEO’s role in improving organic visibility, driving traffic, and ultimately influencing business revenue. Through conceptual explanations and real–world examples, the videos illustrate how SEO blends art and science, why consistent efforts matter, and how human expertise still plays a critical role even in the age of AI-driven search.",
    mainVideo: {
      title: "SEO & its Business Impact",
    },
    episodes: [
      {
        title: "SEO & its Business Impact",
        description: "",
        url: `${process.env.PUBLIC_URL}/Assets/IgniteTalks/bestpractices/seo-video1.mp4`,
        thumbnail: `${process.env.PUBLIC_URL}/Assets/IgniteTalks/bestpractices/seo-thumb1.png`,
        duration: "8 min",
        date: "Dec-12-2025",
      },
      {
        title: "Crawling Indexing & Ranking",
        description: "",
        url: `${process.env.PUBLIC_URL}/Assets/IgniteTalks/bestpractices/seo-video2.mp4`,
        thumbnail: `${process.env.PUBLIC_URL}/Assets/IgniteTalks/bestpractices/seo-thumb2.png`,
        duration: "4 min",
        date: "Dec-12-2025",
      },
      {
        title: "SEO and Its Business Impact_Q&A",
        description: "",
        url: `${process.env.PUBLIC_URL}/Assets/IgniteTalks/bestpractices/seo-video3.mp4`,
        thumbnail: `${process.env.PUBLIC_URL}/Assets/IgniteTalks/bestpractices/seo-thumb3.png`,
        duration: "6 min",
        date: "Dec-12-2025",
      },
      {
        title: "Discover Amethyst",
        description: "",
        url: `${process.env.PUBLIC_URL}/Assets/IgniteTalks/bestpractices/seo-video4.mp4`,
        thumbnail: `${process.env.PUBLIC_URL}/Assets/IgniteTalks/bestpractices/seo-thumb4.png`,
        duration: "5 min",
        date: "Dec-12-2025",
      },
      {
        title: "REACH Framework for Effective Prompting",
        description: "",
        url: `${process.env.PUBLIC_URL}/Assets/IgniteTalks/bestpractices/seo-video5.mp4`,
        thumbnail: `${process.env.PUBLIC_URL}/Assets/IgniteTalks/bestpractices/seo-thumb5.png`,
        duration: "10 min",
        date: "Dec-12-2025",
      },
      {
        title: "Day in Your Life with Amethyst",
        description: "",
        url: `${process.env.PUBLIC_URL}/Assets/IgniteTalks/bestpractices/seo-video6.mp4`,
        thumbnail: `${process.env.PUBLIC_URL}/Assets/IgniteTalks/bestpractices/seo-thumb6.png`,
        duration: "4 min",
        date: "Dec-12-2025",
      },
    ],
  },
];
